import { styled } from '@mui/material/styles'
import Box from '@mui/material/Box'
import { Button } from 'Common/Supplyvue-ui/Button'
import { Typography } from '@mui/material'

export const ContentWrapper = styled(Box)({
  minWidth: '600px',
})

export const ModalActionButton = styled(Button)({
  marginLeft: '20px',
  minWidth: '105px',
})

export const Label = styled(Typography)({
  marginBottom: '8px',
})

export const Progress = styled(Box)({
  marginRight: '8px',
})

export const StyledFooter = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  justifyContent: 'flex-end',
})
